import Contact from "./submit_answers";

const Instructions = [
  {
    name: "1. The result has to be pushed on individuals' GitHub accountsIf the participant doesn't have a GitHub account, please create it before interning the exam ",
    InstructionsData: [
      {
        instructions:
          "a. you can use this link to learn how to create a GitHub account:",
        link: "https://www.youtube.com/watch?v=iv8rSLsi1xo&t=1s",
      },
      {
        instructions: "b. use this one to lean how to push on Github",
        link: "https://www.youtube.com/watch?v=wrb7Gge9yoE",
      },
    ],
  },
  {
    name: "2. The exam doesn't have to exceed 3 hours. The exam has to be done in one seat.",
  },
  {
    name: "4. Participants are allowed to use the internet, however, it's not allowed to cheat on their neighbor or copy source codes from their neighbor. Whenever you copy codes from a neighbor we will be able to recognize it, and it will result in automatic dismissal from our internship",
  },
  {
    name: "5. Once you complete the exam share with us your full names and your Github Answers Repository",
  },
];

const MainContent = () => {
  return (
    <div className=" w-[100%] pt-16   flex flex-col justify-center align-middle">
      <div className="pt-8">
        <div className="text-3xl font-bold text-center">
          <span className="text-[#FFC43B] ">E</span>XAM INSTRUCTIONS
        </div>
        <div className="w-[70%]  text-start mx-auto my-0 pt-8">
          {Instructions.map((element, i) => {
            return (
              <div>
                <div>{element.name}</div>
                {element.InstructionsData && (
                  <div className="pl-5 py-2">
                    {element.InstructionsData.map((el, index) => {
                      return (
                        <div className="flex">
                          <div>{el.instructions}</div>
                          <div>
                            <a
                              className="text-[blue] italic font-bold"
                              target="blank"
                              href={el.link}
                            >
                              {el.link}
                            </a>
                          </div>
                          ;
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            );
          })}
        </div>
        <div className="w-[70%] text-start  mx-auto my-0 pt-8">
          This work is about to test if you match with our training when you
          finish this challenge, you have everything we want so Use visual
          studio code or other your favorite editor to complete this task by
          creating github repository and solve the question when you finish all
          questions submit in form bellow
        </div>
      </div>
      <div className="flex flex-row">
        <div>
          <Contact />
        </div>
      </div>
    </div>
  );
};

export default MainContent;
